import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenAttendancesIndicatorC2Data } from "@/services/esus/indicator/esf/c2/getDetailedCitizensAttendancesIndicatorC2";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC2CitizenAttendancesHistoryItem } from "./IndicatorEsfC2CitizenAttendancesHistoryItem";
import { IndicatorEsfC2CitizenAttendancesHistoryInfo } from "./IndicatorEsfC2CitizenAttendancesHistoryInfo";

type IndicatorEsfC2CitizenAttendancesHistoryProps = {
	citizenWithAttendances: DetailedCitizenAttendancesIndicatorC2Data;
};

export function IndicatorEsfC2CitizenAttendancesHistory({
	citizenWithAttendances,
}: Readonly<IndicatorEsfC2CitizenAttendancesHistoryProps>) {
	const indicatorEsfC1CitizenHistoryInfo = {
		fullName: citizenWithAttendances.fullName ? citizenWithAttendances.fullName : "N/A",
		birthdate: citizenWithAttendances.birthdate
			? dayjs(citizenWithAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithAttendances.cpf
			? formatIdentifier(citizenWithAttendances.cpf)
			: citizenWithAttendances.cns ?? "",
		motherName: citizenWithAttendances.motherName ?? "",
		phone: citizenWithAttendances.phone ? phoneFormat(citizenWithAttendances.phone) : "",
		address:
			addressConcat(
				citizenWithAttendances.street,
				citizenWithAttendances.houseNumber,
				citizenWithAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC2CitizenAttendancesHistoryInfo {...indicatorEsfC1CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Consultas"
				timeLineContents={(citizenWithAttendances.attendances ?? []).map<TimeLineContent>(
					(attendance) => {
						return {
							content: (
								<IndicatorEsfC2CitizenAttendancesHistoryItem
									attendance={attendance}
								/>
							),
							eventDate: attendance.date
								? dayjs(attendance.date).format("DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
			<TimeLine
				timeLineTitle="Registros de Peso e Altura"
				timeLineContents={(
					citizenWithAttendances.weightAndHeightMetricsRegisters ?? []
				).map<TimeLineContent>((metricsAttendance) => {
					return {
						content: (
							<IndicatorEsfC2CitizenAttendancesHistoryItem
								attendance={metricsAttendance}
							/>
						),
						eventDate: metricsAttendance.date
							? dayjs(metricsAttendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
